class EstadosFactura{
  constructor(id,descripcion)
  {
    
    this.id=id
    this.descripcion=descripcion
  }
}

export default EstadosFactura